import React from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import { DictionaryKey } from "src/types/language";

export interface MsgProps {
  id: DictionaryKey;
  values?: Record<string, React.ReactNode>;
}

export const msg = (intl: IntlShape, { id, values }: MsgProps): string =>
  intl.formatMessage({ id }, values as never);

export const Msg: React.FC<MsgProps> = ({ id, values }) => (
  <FormattedMessage id={id} values={values} />
);
